import { Box, Grid2, Typography } from '@mui/material'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CustomDivider from '../../shared/utils/CustomDivider'
import AllCoursesCard from '../../shared/components/student/AllCoursesCard'
import { Grid_Gap } from '../../shared/constants'
import { useStudentCourse, useStudentOnlineCourses } from '../../assets/api/UseStudentGetApi'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import { GridChildren } from '../../shared/utils/LingtBlueContainer'
import TabsComponent from '../../shared/components/Tabs/TabComponent'
import TabPanel from '../../shared/components/Tabs/TabPanel'
import useTabs from '../../shared/hook/useTabs'


const RenderCourses = ({ studentcourses, isLoading }) => {
    const completedCourses = studentcourses?.filter(
        (item) => item.course_status === "Completed Class"
    );

    const ongoingCourses = studentcourses?.filter(
        (item) => item.course_status === "Ongoing Class"
    );

    const upcomingCourses = studentcourses?.filter(
        (item) => item.course_status === "Upcoming Class"
    );

    return (
        <>
            <NormalContainerWithHeader headerText={"Ongoing Events"}>
                <Grid2 container spacing={Grid_Gap}>
                    {!isLoading && (
                        ongoingCourses?.length > 0 ? (
                            ongoingCourses.map((item, index) => (
                                <GridChildren index={index} key={index}>
                                    <AllCoursesCard item={item} />
                                </GridChildren>
                            ))
                        ) : (
                            <Typography variant='body2'>No Ongoing Courses</Typography>
                        )

                    )}
                    {
                        isLoading && (
                            [...Array(2)].map((_, index) => (
                                <GridChildren index={index} key={index}>
                                    <SkeletonCom />
                                </GridChildren>
                            ))
                        )
                    }
                </Grid2>
            </NormalContainerWithHeader>
            <CustomDivider orientation='horizontal' />
            <NormalContainerWithHeader headerText={"Upcoming Events"} isGrid={false}>

                <Grid2 container spacing={Grid_Gap}>

                    {!isLoading && (
                        upcomingCourses?.length > 0 ? (
                            upcomingCourses.map((item, index) => (
                                <GridChildren index={index} key={index}>
                                    <AllCoursesCard item={item} />
                                </GridChildren>
                            ))
                        ) : (
                            <Typography variant='body2'>No Upcoming  Events</Typography>
                        )

                    )}
                    {
                        isLoading && (
                            [...Array(2)].map((_, index) => (
                                <GridChildren index={index} key={index}>
                                    <SkeletonCom />
                                </GridChildren>
                            ))
                        )
                    }
                </Grid2>
            </NormalContainerWithHeader>
            <CustomDivider orientation='horizontal' />
            <NormalContainerWithHeader headerText={"Completed Events"}>
                <Grid2 container spacing={Grid_Gap}>
                    {!isLoading && (
                        completedCourses?.length > 0 ? (
                            completedCourses.map((item, index) => (
                                <GridChildren index={index} key={index}>
                                    <AllCoursesCard item={item} />
                                </GridChildren>
                            ))
                        ) : (
                            <Typography variant='body2'>No Completed Events</Typography>
                        )

                    )}
                    {
                        isLoading && (
                            [...Array(2)].map((_, index) => (
                                <GridChildren index={index} key={index}>
                                    <SkeletonCom />
                                </GridChildren>
                            ))
                        )
                    }
                </Grid2>
            </NormalContainerWithHeader>
        </>
    )
}






const MyEvents = () => {
    const { value, handleChange } = useTabs(0);
    const { data: studentcourses, isLoading } = useStudentCourse({ is_event: 1 });
    const filteredCourses = studentcourses?.data?.filter(course => course.online !== 1);
    const { data: studentonlinecourses, isLoading: isOnlineCourseLoading } = useStudentOnlineCourses({ is_event: 1 });
    const tabsData = [
        { label: "Offline Events", component: <RenderCourses studentcourses={filteredCourses} isLoading={isLoading} /> },
        { label: "Online Events", component: <RenderCourses studentcourses={studentonlinecourses?.data} isLoading={isOnlineCourseLoading} /> }
    ];
    return (
        <Box>

            <CustomDivider orientation='horizontal' />

            <CustomDivider orientation='horizontal' />

            <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
            {tabsData.map((tab, index) => (
                <TabPanel key={index} value={value} index={index}>
                    {tab.component}
                </TabPanel>
            ))}

        </Box>


    )
}

export default MyEvents


